// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1Pam-","options":"AnswerScale_options__NK3Nc","selected":"AnswerScale_selected__apaUE"};